import { useLocation } from "react-router-dom";
import Footer from "../Menu/Footer";
import SideBar from "../Menu/SideBar";
import { useEffect, useState } from "react";
import Routing from "../Routing";

const MyHome = () => {
  const location = useLocation();
  const [menuVisibleFlag, setMenuVisibleFlag] = useState(true);
  useEffect(() => {
    if (location.pathname.includes('/my-login')) {
      setMenuVisibleFlag(false);
    }
    else {
      setMenuVisibleFlag(true);
    }

  }, [location]);
  return (
    <>
      {menuVisibleFlag ? <SideBar /> : ""}
      <Routing />
      {menuVisibleFlag ? <Footer /> : ""}
    </>
  );
}

export default MyHome;

